import { gql } from '@apollo/client';
import { REPORT_FILE_FRAGMENT, REPORT_FRAGMENT } from 'gql/reports/fragments';

import {
  PATIENT_FRAGMENT,
  SHARED_FILE_FRAGMENT,
  SHARED_FOLDER_FRAGMENT
} from './fragments';

export const GET_PATIENTS = gql`
  query PreviousPatients($query: SearchUser!) {
    previousPatients(query: $query) {
      data {
        results {
          ...PatientFragment
        }
        total
      }
    }
  }
  ${PATIENT_FRAGMENT}
`;

export const GET_REPORTS_BY_PATIENT_ID = gql`
  query GetReportsByPatientId($id: ID!, $query: Pagination) {
    getReportsByPatientId(patientId: $id, query: $query) {
      data {
        total
        results {
          ...ReportFragment
        }
      }
    }
  }
  ${REPORT_FRAGMENT}
`;

export const GET_REPORTS_FILE_BY_PATIENT_ID = gql`
  query GetReportsFileByPatientId($id: ID!, $query: Pagination) {
    getReportsFileByPatientId(patientId: $id, query: $query) {
      data {
        total
        results {
          ...ReportFileFragment
        }
      }
    }
  }
  ${REPORT_FILE_FRAGMENT}
`;

export const GET_SHARED_FOLDERS = gql`
  query GetSharedFolders($query: GetSharedFoldersQuery) {
    getSharedFolders(query: $query) {
      data {
        ...SharedFolderFragment
        children {
          ...SharedFolderFragment
        }
        files {
          ...SharedFileFragment
        }
      }
    }
  }
  ${SHARED_FILE_FRAGMENT}
  ${SHARED_FOLDER_FRAGMENT}
`;

export const GET_ANALYSIS_BY_PATIENT_ID = gql`
  query GetAnalysisByPatientId($id: ID!, $query: AnalysisInput) {
    getAnalysisByPatientId(id: $id, query: $query) {
      data {
        results {
          title
          summary
          analysis
          created_at
          file
          id
          status
        }
        total
      }
    }
  }
`;

export const GET_ANALYSIS_BY_ID = gql`
  query GetAnalysisById($id: ID!) {
    getAnalysisById(id: $id) {
      data {
        id
        file
        analysis
        summary
        title
        status
        created_at
      }
    }
  }
`;
